import { Container } from "pixi.js";

export const hook = {
    viewport: null,
}